module.exports = __webpack_public_path__ + "img/Moglix1.90e4096c.png";